<div class="dialog">
  <h2>Verify corporate domain</h2>

  @if (!verificationCode.value && !fetchDnsCodeError) {
    <app-spinner>
      Loading DNS verification code...
    </app-spinner>
  }

  @if (fetchDnsCodeError) {
    <div class="error-container">
      <img alt="Alert" src="/assets/default/alert.svg">
      <div class="error-message">
        Loading DNS verification code failed.
      </div>
    </div>
  }

  @if (verificationCode.value && !fetchDnsCodeError) {
    <p>
      In order to proceed with domain verification please copy the Nomidio Verification TXT and add it to your domain host's DNS records.
    </p>
    <p>
      Please note DNS propagation can take up to 48 hours, if verification does not succeed please try again at a later time.
    </p>
    <form [formGroup]="dnsForm" (submit)="verifyDnsRecord()" class="dns-form">
      <app-text-input
        [control]="verificationCode"
        name="Nomidio Verification TXT record"
        [copy]="true"
        [readonly]="true"
        >
        <button type="submit" class="btn btn-primary btn-medium" [disabled]="busy">Verify</button>
      </app-text-input>
    </form>
  }

  @if (verifyDnsError) {
    <div class="error-container">
      <img alt="Alert" src="/assets/default/alert.svg">
      <div class="error-message">
        There seems to be a problem verifying this domain.
      </div>
    </div>
  }

  @if (verificationTxtNotFoundError) {
    <div class="error-container">
      <img alt="Alert" src="/assets/default/alert.svg">
      <div class="error-message">
        TXT record not found.
      </div>
    </div>
  }

  <div class="button-group button-group--center">
    <button type="button" class="btn btn-secondary btn-medium" (click)="onCancel()">Done</button>
  </div>
</div>
